<project-navigation
  [headerTitle]="'projectNavigation.cae_import_title'"
  [headerText]="'projectNavigation.cae_import_message'"
  [model]="model"
  [submitEnabled]="submitEnabled"
  [visibleFeatures]="{
    compositeCheckBox: false,
    pinnedProjects: false,
    recentlyUsedProjects: false,
    history: true,
    projectActionsMenu: true,
    projectGroupContextMenu: true,
    newConfigurationGroupBtn: true,
    newFolderBtn: true,
    dialogSearch: true,
    tabs: true,
    breadcrumbs: true,
  }"
  [actionButtonLabel]="'global.label.save'"
  (submitEnabledChanged)="updateSubmitEnabled()"
  (actionBtnClick)="importCae()"
  (cancel)="cancel()"
></project-navigation>
